<template>
    <div>
        <div class="leaveWord">
            <avue-crud :data="data" :option="option" ></avue-crud>
        </div>
    </div>
</template>

<script>
    import { checkMessage } from '../../../api/arbitrationCase';

    export default {
        name: 'checkMessage',
        data() {
            return {
                id:'',
                data: [
                ],
                option:{
                    stripe:true,
                    addBtn:false,
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menu:false,
                    align:'center',
                    column:[
                        {
                            label:'留言人姓名',
                            prop:'user_name'
                        }, {
                            label: '留言内容',
                            prop: 'content'
                        },{
                            label:'留言时间',
                            prop:'create_time'
                        }
                    ]
                },
            };
        },
        created() {
            checkMessage(this.$route.query.id).then(res=>{
                if (res.code==200){
                    this.data=res.data.list
                }
            })
        }
    };
</script>

<style scoped>
    .leaveWord{
        background-color: #fff;
        padding: 30px;
        border-radius: 5px;
    }
</style>
